import axios from "axios";
import Vue from "vue";

import clientLogger from "./client";
// import { generateComponentTrace } from "./component-stack";
import { env, logLevel } from "./config";
import serverLogger from "./server";
import { Logger, isError, logLevelPriority } from "./types";

export { type LogLevel, logLevel } from "./types";

const logger: Logger = (level, message, context = {}, ...rest) => {
  // Filter log messages below configured logging level
  if (logLevelPriority.indexOf(level) < logLevelPriority.indexOf(logLevel)) {
    return;
  }

  rest.forEach((param) => {
    if (param === undefined || param === null) {
      return;
    }

    // Translate any `vm` parameters into component stack traces
    if (param instanceof Vue) {
      // const stack = generateComponentTrace(param);
      // context.component = { stack };
    }

    // Translate error parameters into an object
    if (isError(param)) {
      const { name, message, stack, cause } = param;
      context.error = {
        // Standard Error Properties
        name,
        message,
        stack,
        cause,
      };

      if (axios.isAxiosError(param)) {
        context.error = Object.assign({}, context.error, param.toJSON());
      }
    }
  });

  if (process.server && env !== "local" && env !== "development") {
    serverLogger(level, message, context, ...rest);
  }

  if (process.client || env === "local" || env === "development") {
    clientLogger(level, message, context, ...rest);
  }
};

export default logger;
